module.exports = __webpack_public_path__ + "static/media/9.8fe7953c.jpg";